import { N13_03 } from "./N13_03";

export const N13_02 = {
  selectedValueColumn: "Region",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "District",
                columnName: "DistrictName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Completed",
                columnName: "CompletedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Frequency",
                columnName: "CallFrequency",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "DistrictName",
            endpoint: "N13.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "Region", value: "" }
            ],
          },
          context: {
            point: {
              onClick: N13_03,
            },
          },
        },
      },
    },
  ],
};